<template>
  <div>
    <b-breadcrumb :items="items"></b-breadcrumb>

    <b-row class="mx-0 mb-3">
      <b-card v-if="suggested" class="suggestion">
        <strong>Suggestion :</strong>
        {{ suggested }}
      </b-card>
      <b-col>
        <b-card
          title="Traductions"
          sub-title="Gestion des traductions contextuelles du Recuperator"
          bg-variant="secondary"
          class
        >
          <b-card>
            <b-row>
              <b-col lg="12">
                <b-alert
                  v-if="alertMessage !== ''"
                  @dismissed="alertMessage = ''"
                  show
                  dismissible
                  >{{ alertMessage }}</b-alert
                >
              </b-col>
            </b-row>

            <b-row align-v="center">
              <b-col lg="2">Contexte</b-col>
              <b-col lg="6" v-if="contextsLoaded">
                <b-form-group class="my-0">
                  <b-select
                    @change="loadContext"
                    v-model="contextID"
                    :options="contexts"
                    value-field="ID"
                    text-field="label"
                  ></b-select>
                </b-form-group>
              </b-col>
              <b-col lg="2">
                <b-button
                  :disabled="newContextScope"
                  @click="openNewContextField"
                  block
                  variant="secondary"
                  >Ajouter un contexte</b-button
                >
              </b-col>
              <b-col lg="2">
                <b-button
                  :disabled="newLanguageScope"
                  @click="openNewLanguageField"
                  block
                  variant="secondary"
                  >Gérer les langues</b-button
                >
              </b-col>
            </b-row>
            <b-row v-if="newLanguageScope" class="mt-3">
              <b-col lg="4" offset-lg="2">
                <b-form-group label-cols-lg="2" label-size="sm" label="Langues">
                  <b-form-select
                    autofocus
                    multiple
                    :select-size="8"
                    :options="availableLanguages"
                    v-model="selectedLanguages"
                  ></b-form-select>
                </b-form-group>
              </b-col>
              <b-col
                lg="2"
                class="d-flex justify-content-between align-items-center"
              >
                <b-button @click="cancelNewLanguage" variant="danger"
                  >Annuler</b-button
                >
                <b-button @click="submitNewLanguage" variant="success"
                  >Sélectionner</b-button
                >
              </b-col>
            </b-row>
            <b-row v-if="newContextScope" class="mt-3">
              <b-col lg="6" offset-lg="2">
                <b-form-group
                  label-cols-lg="2"
                  label-size="sm"
                  label="Nom du contexte"
                >
                  <b-form-input
                    size="sm"
                    autofocus
                    @keydown.enter="submitNewContext"
                    v-model="newContext.label"
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col lg="6" offset-lg="2">
                <b-form-group
                  label-cols-lg="2"
                  label-size="sm"
                  label="Slug (développement)"
                >
                  <b-form-input
                    size="sm"
                    @keydown.enter="submitNewContext"
                    v-model="newContext.slug"
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col lg="6" offset-lg="2">
                <b-form-group
                  label-cols-lg="2"
                  label-size="sm"
                  label="Description"
                >
                  <b-form-input
                    size="sm"
                    @keydown.enter="submitNewContext"
                    v-model="newContext.description"
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col
                lg="2"
                offset-lg="6"
                class="d-flex justify-content-between"
              >
                <b-button @click="cancelNewContext" variant="danger"
                  >Annuler</b-button
                >
                <b-button @click="submitNewContext" variant="success"
                  >Ajouter</b-button
                >
              </b-col>
            </b-row>
          </b-card>
          <b-row class="mt-3">
            <b-col lg="10">
              <b-card v-if="translationsLoaded">
                <b-row class="mb-3">
                  <b-col lg="2">
                    <b-form-group v-if="languagesLoaded" class="my-0" label="Label" label-size="sm" label-class="mb-0">
                      <b-select v-model="selectedLabel" :options="translations" value-field='label' text-field="label">

                      </b-select>
                    </b-form-group>

                  </b-col>
                  <b-col lg="2" v-if="languagesLoaded">
                    <b-form-group
                      class="my-0"
                      label="Langue source"
                      label-size="sm"
                      label-class="mb-0"
                    >
                      <b-select
                        v-model="sourceLanguageID"
                        :options="languages.filter((x) => x.active == 1)"
                        value-field="ID"
                        text-field="label"
                      ></b-select>
                    </b-form-group>
                  </b-col>
                  <b-col offset-lg="3" lg="2" v-if="languagesLoaded">
                    <b-form-group
                      class="my-0"
                      label="Langue de destination"
                      label-size="sm"
                      label-class="mb-0"
                    >
                      <b-select
                        v-model="targetLanguageID"
                        :options="languages.filter((x) => x.active == 1)"
                        value-field="ID"
                        text-field="label"
                      ></b-select>
                    </b-form-group>
                  </b-col>
                </b-row>
                <div v-for="(translation, index) in translations.filter(x => x.label == selectedLabel)" :key="index">
                  <b-row align-v="center" class="mb-2">
                    <b-col lg="2">
                      <span
                        v-if="editedLabel !== index"
                        class="d-flex justify-content-between align-items-center"
                      >
                        <span @click="editLabel(index)" class="label">{{
                          translation.label
                        }}</span>
                        <span v-if="$store.getters.isSuperAdmin">
                          <b-icon-x-circle
                            class="float-right deleteEntry"
                            @click="deleteLabelModal(index)"
                            variant="danger"
                          ></b-icon-x-circle>
                        </span>
                      </span>

                      <span v-else>
                        <b-input
                          @blur="updateLabel(index)"
                          autofocus
                          block
                          v-model="translation.label"
                        ></b-input>
                      </span>
                    </b-col>
                    <b-col lg="5">
                      <b-textarea
                        rows="1"
                        max-rows="8"
                        no-auto-shrink
                        @change="updateLabel(index)"
                        v-model="translation.traduction[sourceLanguageID].str"
                        :class="
                          translation.traduction[sourceLanguageID].str.trim() ==
                          ''
                            ? 'emptyemptyTranslation'
                            : ''
                        "
                      ></b-textarea>
                    </b-col>
                    <b-col lg="5">
                      <b-textarea
                        rows="1"
                        max-rows="8"
                        no-auto-shrink
                        @change="updateLabel(index)"
                        v-model="translation.traduction[targetLanguageID].str"
                        :class="
                          translation.traduction[targetLanguageID].str.trim() ==
                          ''
                            ? 'emptyTranslation'
                            : ''
                        "
                      ></b-textarea>
                    </b-col>
                    <b-col lg="2"></b-col>
                  </b-row>
                </div>
                <b-row class="mt-3">
                  <b-col v-if="newLabelScope" lg="2">
                    <b-form-input
                      autofocus
                      @keydown.enter="submitNewLabel"
                      v-model="newLabel"
                    ></b-form-input>
                  </b-col>
                  <b-col offset-lg="10" lg="2">
                    <b-button
                      :disabled="newLabelScope"
                      @click="openNewLabelField"
                      block
                      variant="secondary"
                      >Ajouter une entrée</b-button
                    >
                  </b-col>
                </b-row>
              </b-card>
            </b-col>
            <b-col lg="2">
              <b-card id="variables">
                <b-card-header>Variables</b-card-header>
                <b-list-group>
                  <b-list-group-item
                    v-for="(method, index) in methods"
                    :key="index"
                  >
                    <small>{{ method }}</small>
                  </b-list-group-item>
                </b-list-group>
              </b-card>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import translations from "@/services/translations.js";

export default {
  name: "translations",
  data() {
    return {
      selectedLanguages: [],
      selectedLabel: null,
      alert_key: 0,
      suggested: null,
      methods: [],
      editedLabel: null,
      alert: false,
      alertMessage: "",
      newLanguageScope: false,
      newLanguage: {
        iso: "",
        label: "",
        active: false,
        ID: null,
      },
      newContextScope: false,
      newLabelScope: false,
      newLabel: "",
      newContext: {
        label: "",
        description: "",
        slug: "",
        ID: null,
      },
      contextID: 1,
      contexts: [],
      languages: [],
      sourceLanguageID: 1,
      targetLanguageID: 2,
      translations: {},
      translationsLoaded: false,
      contextsLoaded: false,
      languagesLoaded: false,
      items: [
        {
          text: "Gestion",
          to: { name: "home" },
        },
        {
          text: "Administration",
          to: { name: "administration" },
        },
        {
          text: "Traductions",
          active: true,
        },
      ],
    };
  },
  computed: {
    availableLanguages() {
      return this.languages.map((x) => {
        if (x.ID == 1) {
          return {
            value: x.ID,
            text: x.label + " (langue source)",
            disabled: true,
          };
        }
        return {
          value: x.ID,
          text: x.label,
        };
      });
    },
  },
  created() {
    this.load();
  },
  methods: {
    load() {
      translations.getContexts().then((response) => {
        this.contexts = response.data;
        this.contextsLoaded = true;
        translations.getActiveLanguages().then((response) => {
          this.languages = response.data;
          this.languagesLoaded = true;
          this.selectedLanguages = this.languages
            .filter((x) => x.active == 1)
            .map((x) => x.ID);

          translations.getContext(this.contextID).then((response) => {
            this.translations = response.data.translations;
            this.methods = response.data.methods;
            this.selectedLabel = this.translations[0].label || null
            this.translationsLoaded = true;
          });
        });
      });
    },
    suggestion(index) {
      console.log(
        this.translations[index].traduction[this.sourceLanguageID].str
      );
      if (
        this.translations[index].traduction[this.targetLanguageID].str == ""
      ) {
        translations
          .suggestion({
            ID: this.translations[index].traduction[this.sourceLanguageID].ID,
            source: this.sourceLanguageID,
            target: this.targetLanguageID,
            text: this.translations[index].traduction[this.sourceLanguageID]
              .str,
          })
          .then((response) => {
            if (response.data.error) {
              this.suggested = "";
            } else {
              this.suggested = response.data.suggestion;
            }
            this.alert_key++;
          });
      }
    },
    loadContext() {
      translations.getContext(this.contextID).then((response) => {
        this.translations = response.data.translations;
        this.methods = response.data.methods;
        this.selectedLabel = this.translations[0].label || null
        this.translationsLoaded = true;
      });
    },
    openNewLanguageField() {
      this.newLanguageScope = true;
      this.newLanguage = {
        iso: "",
        label: "",
        active: false,
        ID: null,
      };
    },
    cancelNewLanguage() {
      this.newLanguageScope = false;
      this.selectedLanguages = this.languages
        .filter((x) => x.active == 1)
        .map((x) => x.ID);
      this.alertMessage = "";
    },

    openNewContextField() {
      this.newContextScope = true;
      this.newContext = {
        label: "",
        description: "",
        slug: "",
        ID: null,
      };
    },
    openNewLabelField() {
      this.newLabelScope = true;
      this.newLabel = "";
    },
    editLabel(index) {
      this.editedLabel = index;
    },
    updateLabel() {
      this.editedLabel = null;
      translations.save(JSON.stringify(this.translations));
    },
    cancelNewContext() {
      this.newContextScope = false;
      this.alertMessage = "";
    },
    submitNewLanguage() {
      translations
        .selectLanguages({ selected: this.selectedLanguages })
        .then(() => {
          this.newLanguageScope = false;

          translations.getContexts().then((response) => {
            this.contexts = response.data;
            this.contextsLoaded = true;
            translations.getActiveLanguages().then((response) => {
              this.languages = response.data;
              this.languagesLoaded = true;
              translations.getContext(this.contextID).then((response) => {
                this.translations = response.data.translations;
                this.methods = response.data.methods;
                this.translationsLoaded = true;
              });
            });
          });
        });
    },
    submitNewLabel() {
      if (
        this.translations.find(
          (element) =>
            element.label.toLowerCase().trim() ==
            this.newLabel.toLowerCase().trim()
        )
      ) {
        this.alert = true;
        this.alertMessage = "Cette entrée existe déjà";
      } else {
        this.newLabelScope = false;
        translations
          .addLabel({ label: this.newLabel, contextID: this.contextID })
          .then(() => {
            this.load();
          });
      }
    },
    submitNewContext() {
      if (
        this.contexts.find(
          (element) =>
            element.label.toLowerCase().trim() ==
            this.newContext.label.toLowerCase().trim()
        )
      ) {
        this.alert = true;
        this.alertMessage = "Ce contexte existe déjà";
      } else {
        this.newContextScope = false;
        translations.addContext(this.newContext).then((response) => {
          this.contextID = response.data.ID.value;
          translations.getContexts().then((response) => {
            this.contexts = response.data;
            this.contextsLoaded = true;
            translations.getActiveLanguages().then((response) => {
              this.languages = response.data;
              this.languagesLoaded = true;
              translations.getContext(this.contextID).then((response) => {
                this.translations = response.data;
                this.translationsLoaded = true;
              });
            });
          });
        });
      }
    },
    deleteLabelModal(index) {
      this.$bvModal
        .msgBoxConfirm(
          "Êtes-vous sûr de vouloir supprimer cette entrée? \nSi cette entrée est utilisée par le Recuperator, elle sera automatiquement rajoutée mais les informations de traduction seront perdues.",
          {
            title: "Confirmez",
            okTitle: "Supprimer",
            cancelTitle: "Annuler",
          }
        )
        .then((value) => {
          if (value) {
            translations
              .deleteLabel({
                label: this.translations[index].label,
                contextID: this.translations[index].contextID,
              })
              .then(() => {
                this.translations.splice(index, 1);
              });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.deleteEntry {
  opacity: 0.3;
  &:hover {
    cursor: pointer;
    opacity: 1;
    transition: all 0.5s;
  }
}
.label {
  padding: 10px;
  border: 1px solid transparent;
  border-radius: 4px;
  &:hover {
    cursor: pointer;
    border: 1px solid gray;
    transition: all 0.5s;
  }
}
.emptyTranslation {
  border: 2px dotted red;
}
#variables {
  position: -webkit-sticky; /* Safari */
  position: sticky;
  top: 100px;
  height: 90vh;
  .card-body .list-group {
    overflow-y: scroll;
    max-height: 90%;
  }
}
.suggestion {
  position: fixed;
  left: 20px;
  top: 50vh;
  z-index: 1000;
}
</style>